export default {
	title: '已停用项',
	empty: '本场景中无已停用项',
	no_scenario: '请选择场景以查看已停用项'
};
